import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {UrlUtils} from '@pt/pt-core';
import {XDOMAIN, XTENANTID} from "@pt/pt-models";



@Injectable({
  providedIn: 'root'
})
export class DomainInterceptor implements HttpInterceptor {

  private warningUrlRegex = [
    '.*\\/api\\/org\\/treatments-holder\\/.*\\/lock'
  ];

  constructor(private store: Store) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = request.headers;
    let domain = localStorage.getItem(XTENANTID);

    /*
    * fallback if no domain available. Try to recover
    * it and save to localStorage.
    * */
    if (domain === null || domain === undefined) {
      domain = UrlUtils.getDomainIfExists();
      if (domain) {
        localStorage.setItem(XTENANTID, domain);
      }
    }

    if (domain) {
      headers = headers.set(XDOMAIN, domain);
      // headers = headers.set(XTENANTID, domain);
      request = request.clone({
        headers: headers
      });
    }

    if (request.url.endsWith('api/org/v2/cyber-sec/scan')) {
      headers = headers.set(XDOMAIN, 'primatoo');
      headers = headers.set(XTENANTID, 'primatoo');
      request = request.clone({
        headers: headers
      });
    }
    // request = request.clone({withCredentials: true});

    return next.handle(request);
  }
}
